import {
  ChangeDetectorRef, Component, Input, ViewChild, ElementRef,
  OnInit, OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';

import { BrandService } from 'shared/brand/brand.service';
import { ProcessService } from 'shared/process/process.service';
import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { ReceiversSearchService } from 'shared/receivers/search/receivers-search.service';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { SearchModel } from 'shared/search/search.model';
import { LoaderComponent } from 'shared/loader/loader.component';
import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { SIMPLE_FILTER_TYPE } from 'shared/search/active-filters/active-filter-types';
import { SearchInputComponent } from 'shared/search/search-input/search-input.component';
import {takeWhile} from 'rxjs/operators';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'receiver-search',
  templateUrl: 'receiver-search.component.html',
  styleUrls: ['receiver-search.component.scss'],
})
export class ReceiverSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Input() sortingColumns: Array<any> = [];

  @ViewChild(HiddenScrollComponent, {static: false})
  hiddenScroll: HiddenScrollComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent | void;

  ghostValue: string = 'receiver-search';
  isSearchRunning: boolean = false;

  private isActive: boolean = true;

  constructor(
    public searchService: ReceiversSearchService,
    protected brandService: BrandService,
    protected ref: ChangeDetectorRef,
    private processService: ProcessService,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get isEmptyState(): boolean {
     return (!this.searchResults.length && !this.isSearchRunning);
   }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

   ngOnInit() {
     this.searchModel = new SearchModel();
     this.setFilter('doNotSell', 0);
     this.setFilter('readyToReceive', 1);
     _.set(this.searchModel, 'statusModel.id', 2);
   }

   ngOnDestroy() {
     this.destroy();
   }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onSearchByTermClick() {
    this.searchByTerm(_.get(this.searchInput, 'searchTermValue'));
  }

  onClearSearchClick() {
    this.reset();
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.searchValue = '';
      this._searchModel.next(this.searchModel);
    }
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public init() {
    this.initSubscriptions();
  }

  public destroy() {
    this.destroySubscriptions();
    this.isActive = false;
  }

  public runSearch(searchModel: SearchModel) {
    if (this.loader) {
      this.loader.show();
    }
    this.isSearchRunning = true;
    this.ref.markForCheck();
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .pipe(takeWhile(() => this.isActive))
    .subscribe((res: any) => {
      this.isSearchRunning = false;
      if (this.loader) {
        this.loader.hide();
      }
      this.ref.markForCheck();
    });
  }

  public searchByTerm(searchTerm: string): void {
    this.searchService.selectAllChecked = [];
    this.searchService.selectedItems = [];
    this.searchService.allSelected = false;
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.selectAll = null;
      this.searchModel.searchValue = searchTerm;
    }
    this.ref.markForCheck();
    if (this.searchModel instanceof SearchModel) {
      this._searchModel.next(this.searchModel);
    }
  }

  public updateSearch(): void {
    if (this.searchModel instanceof SearchModel) {
      this._searchModel.next(this.searchModel);
    }
  }

  public reset(): void {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.selectAll = 'on-page';
    }
    if (this.searchInput) {
      this.searchInput.resetValue();
    }
  }

  public deselectAll() {
    this.searchService.deselectAll();
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.selectAll = 'on-page';
    }
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private setFilter(name: string, value: number) {
    const filter = new ActiveFilterModel(
      name,
      name,
      SIMPLE_FILTER_TYPE,
      value,
      null,
    );
    if (this.searchModel instanceof SearchModel) {
      this.searchModel.filters.push(filter);
    }
  }
}
